/*
import axios from 'axios'
import config from '../settings/bananas'

const header = {
  'Content-Type': 'application/json'
}

let trackingUrl = config.tracking.url

if (window.location.hostname === 'localhost') {
  trackingUrl = 'http://localhost:3000'
}
*/

export default {
  trackPage(pageData) {
    /*
    axios.post(
      trackingUrl + '/tracking/bn/page/',
      pageData,
      {
        headers: header
      }
    ).then(function (response) {
      return response.data
    })
    */
  },
  getAllPages() {
    /*
    axios.post(
      trackingUrl + '/tracking/bn/page/get/all',
      {},
      {
        headers: header
      }
    ).then(function (response) {
      return response.data
    })
    */
  }
}
